"use client";

import { useEffect } from "react";
import { logErrorToRollbar } from "@/services/rollbar";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    logErrorToRollbar(error, { digest: error.digest, context: 'global-error' });
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
          <h2 className="mb-4 text-2xl font-bold text-primary">Something went wrong!</h2>
          <button
            onClick={() => reset()}
            className="rounded-full bg-primary px-8 py-3 font-bold text-white transition hover:bg-sky-600 cursor-pointer"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
